// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "utf-8";
/* CSS Document */

/* 

	Template Name: Bootstrap 5 Multipurpose Business Website Template
	Author: Rainbow Design
	
*/

/* Medium Devices, Desktops */
@media (max-width: 991px) {
.header-lover .navbar .nav-item .nav-link {
	font-size: 10px;
	padding: 10px 8px;
}
.call-to-action-area h2 {
	font-size: 34px;
}
.footer-link li {
	margin: 0px 12px 0px 0px !important;
}
}
/* Small Devices, Tablets */
@media (max-width: 767px) {
.header-lover:after {
	width: 45%;
}
.header-lover .navbar .navbar-collapse {
	border: 2px solid #00bcd4;
	background-color: #fff;
	z-index: 999;
	padding: 10px;
}
.slider .carousel-indicators {
	display: none;
}
.slider h2 {
	font-size: 22px;
}
.header .dropdown-menu .dropdown-item {
	font-size: 10px;
}
.header-lover {
	padding: 10px 0px !important;
}
.is-sticky .header-lover .navbar .nav-item .nav-link {
	color: #202020;
}
.is-sticky .nav-pills .show > .nav-link {
	color: #202020 !important;
}
.header {
	height: 80px;
}
.footer-contact li {
	width: 100%;
	margin-right: 0 !important;
}
.footer-bottom {
	text-align: center;
}
.footer-copyright {
	margin-top: 12px;
}
.inner-page-title-area {
	padding: 100px 0px;
}
.filter1 {
	border-radius: 6px;
	padding: 10px 10px 4px 10px;
}
.filter1 li {
	margin-right: 0px !important;
	width: 49%;
	margin-bottom: 6px;
}
.filter1 li span {
	padding: 10px;
	display: inline-block;
	position: relative;
	border-radius: 6px;
	font-size: 12px;
	width: 100%;
}
.share-social {
	margin-top: 20px;
}
}
/* Extra Small Devices, Phones */
@media (max-width: 575px) {
.header-lover:after {
	width: 57%;
	z-index: 2;
}
.header-lover .navbar-brand {
	z-index: 3;
}
.slider .carousel-caption .white-box {
	padding: 10px;
}
.slider .carousel-caption .white-box p {
	display: none;
}
.slider h2 {
	font-size: 16px;
}
.slider .btn-style-1, .slider .btn-style-2 {
	padding: 6px 14px;
	font-size: 10px;
}
.footer-link li {
	margin: 0px 0px 0px 0px !important;
	width: 49%;
}
.inner-page-title-area h1 {
	font-size: 26px;
}
.inner-page-title-area h1 span:before {
	right: -10px;
}
.inner-page-title-area h1 span:after {
	left: -10px;
}
.comments-box .img-wrapper {
	width: 100%;
}
.comments-box .text-wrapper {
	padding-left: 0px;
	padding-top: 20px;
	width: 100%;
}
.singal-blog-post .tags-post a {
	padding: 4px 8px;
}
}
`, "",{"version":3,"sources":["webpack://./src/composant/css/responsive.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,iBAAiB;;AAEjB;;;;;CAKC;;AAED,6BAA6B;AAC7B;AACA;CACC,eAAe;CACf,iBAAiB;AAClB;AACA;CACC,eAAe;AAChB;AACA;CACC,mCAAmC;AACpC;AACA;AACA,2BAA2B;AAC3B;AACA;CACC,UAAU;AACX;AACA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,YAAY;CACZ,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,cAAc;AACf;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,YAAY;AACb;AACA;CACC,WAAW;CACX,0BAA0B;AAC3B;AACA;CACC,kBAAkB;AACnB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,2BAA2B;AAC5B;AACA;CACC,4BAA4B;CAC5B,UAAU;CACV,kBAAkB;AACnB;AACA;CACC,aAAa;CACb,qBAAqB;CACrB,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,WAAW;AACZ;AACA;CACC,gBAAgB;AACjB;AACA;AACA,gCAAgC;AAChC;AACA;CACC,UAAU;CACV,UAAU;AACX;AACA;CACC,UAAU;AACX;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,eAAe;AAChB;AACA;CACC,iBAAiB;CACjB,eAAe;AAChB;AACA;CACC,kCAAkC;CAClC,UAAU;AACX;AACA;CACC,eAAe;AAChB;AACA;CACC,YAAY;AACb;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,iBAAiB;CACjB,iBAAiB;CACjB,WAAW;AACZ;AACA;CACC,gBAAgB;AACjB;AACA","sourcesContent":["@charset \"utf-8\";\r\n/* CSS Document */\r\n\r\n/* \r\n\r\n\tTemplate Name: Bootstrap 5 Multipurpose Business Website Template\r\n\tAuthor: Rainbow Design\r\n\t\r\n*/\r\n\r\n/* Medium Devices, Desktops */\r\n@media (max-width: 991px) {\r\n.header-lover .navbar .nav-item .nav-link {\r\n\tfont-size: 10px;\r\n\tpadding: 10px 8px;\r\n}\r\n.call-to-action-area h2 {\r\n\tfont-size: 34px;\r\n}\r\n.footer-link li {\r\n\tmargin: 0px 12px 0px 0px !important;\r\n}\r\n}\r\n/* Small Devices, Tablets */\r\n@media (max-width: 767px) {\r\n.header-lover:after {\r\n\twidth: 45%;\r\n}\r\n.header-lover .navbar .navbar-collapse {\r\n\tborder: 2px solid #00bcd4;\r\n\tbackground-color: #fff;\r\n\tz-index: 999;\r\n\tpadding: 10px;\r\n}\r\n.slider .carousel-indicators {\r\n\tdisplay: none;\r\n}\r\n.slider h2 {\r\n\tfont-size: 22px;\r\n}\r\n.header .dropdown-menu .dropdown-item {\r\n\tfont-size: 10px;\r\n}\r\n.header-lover {\r\n\tpadding: 10px 0px !important;\r\n}\r\n.is-sticky .header-lover .navbar .nav-item .nav-link {\r\n\tcolor: #202020;\r\n}\r\n.is-sticky .nav-pills .show > .nav-link {\r\n\tcolor: #202020 !important;\r\n}\r\n.header {\r\n\theight: 80px;\r\n}\r\n.footer-contact li {\r\n\twidth: 100%;\r\n\tmargin-right: 0 !important;\r\n}\r\n.footer-bottom {\r\n\ttext-align: center;\r\n}\r\n.footer-copyright {\r\n\tmargin-top: 12px;\r\n}\r\n.inner-page-title-area {\r\n\tpadding: 100px 0px;\r\n}\r\n.filter1 {\r\n\tborder-radius: 6px;\r\n\tpadding: 10px 10px 4px 10px;\r\n}\r\n.filter1 li {\r\n\tmargin-right: 0px !important;\r\n\twidth: 49%;\r\n\tmargin-bottom: 6px;\r\n}\r\n.filter1 li span {\r\n\tpadding: 10px;\r\n\tdisplay: inline-block;\r\n\tposition: relative;\r\n\tborder-radius: 6px;\r\n\tfont-size: 12px;\r\n\twidth: 100%;\r\n}\r\n.share-social {\r\n\tmargin-top: 20px;\r\n}\r\n}\r\n/* Extra Small Devices, Phones */\r\n@media (max-width: 575px) {\r\n.header-lover:after {\r\n\twidth: 57%;\r\n\tz-index: 2;\r\n}\r\n.header-lover .navbar-brand {\r\n\tz-index: 3;\r\n}\r\n.slider .carousel-caption .white-box {\r\n\tpadding: 10px;\r\n}\r\n.slider .carousel-caption .white-box p {\r\n\tdisplay: none;\r\n}\r\n.slider h2 {\r\n\tfont-size: 16px;\r\n}\r\n.slider .btn-style-1, .slider .btn-style-2 {\r\n\tpadding: 6px 14px;\r\n\tfont-size: 10px;\r\n}\r\n.footer-link li {\r\n\tmargin: 0px 0px 0px 0px !important;\r\n\twidth: 49%;\r\n}\r\n.inner-page-title-area h1 {\r\n\tfont-size: 26px;\r\n}\r\n.inner-page-title-area h1 span:before {\r\n\tright: -10px;\r\n}\r\n.inner-page-title-area h1 span:after {\r\n\tleft: -10px;\r\n}\r\n.comments-box .img-wrapper {\r\n\twidth: 100%;\r\n}\r\n.comments-box .text-wrapper {\r\n\tpadding-left: 0px;\r\n\tpadding-top: 20px;\r\n\twidth: 100%;\r\n}\r\n.singal-blog-post .tags-post a {\r\n\tpadding: 4px 8px;\r\n}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
